export default "__VITE_ASSET__bb197b0b__"